/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/* APP / SERVIÇOS */

import AppConfig, {IPropsNavigacao} from './AppConfig';
// import { IInfoUser } from './servicos/app/userService';
import { useAppContextoReact } from './servicos/app/AppContextoReact';

/* INTERFACES / ENUMERAÇÕES */

import { EICONS } from './servicos/EICONS';

/* MUI COMPONENTES */

import
{
	Box,
	Drawer as MuiDrawer,
	Toolbar,
	List,
	Typography,
	Divider,
	IconButton,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Collapse
} from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

/* MUI ICONS */

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import LocalMoviesOutlinedIcon from '@mui/icons-material/LocalMoviesOutlined';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import CameraIndoorOutlinedIcon from '@mui/icons-material/CameraIndoorOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/* STYLES / ASSETS */

import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import LogoFrm from './assets/svg/LogoFRMIcone';
import { User } from 'firebase/auth';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { ETABLE } from './componentes/tabelas/ITabelas';

interface IPropsDashboard
{
	children: any
}

const DashboardLayout = (props:IPropsDashboard) =>
{
	const theme = useTheme();
	const location = useLocation();
	const navigate = useNavigate();
	const appContext = useAppContextoReact();

	const [user, setUser] = React.useState<User|null|undefined>(null);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const [ehCarregando, setEhCarregando] = React.useState<boolean>(true);
	const [open, setOpen] = React.useState(true);
	const [accordionItens, setAccordionItens] = React.useState<string[]>([]);

	async function pageLoad()
	{
		try
		{
			await appContext?.usuario.ehLogado();

			setUser(appContext?.usuario.user)
			
		}
		catch(e)
		{
			navigate(AppConfig.PATHS.Login.Login as string);
			console.log(e);
		}
		finally
		{
			setEhCarregando(false);
		}
	}

	async function getPermissaoLoad()
	{
		try {
			await appContext.usuario.getPermissao()
				.then(permissao => setUserRolerAdmin(permissao.administrador || null))
				.catch(error => { console.error('Erro ao obter reivindicações personalizadas:', error) }); 
		} catch (error) {
			console.log(error);
		}

	}

	React.useEffect(() =>
	{
		pageLoad();
	},[appContext])
	
	React.useEffect(() =>
	{
		getPermissaoLoad()
	},[appContext.permissao])

	const handleDrawerOpen = () =>
	{
		setOpen(true);
	};

	const handleDrawerClose = () =>
	{
		setOpen(false);
	};

	const handleGoTo = (page:string) =>
	{
		window.location.href = AppConfig.URL.baseURL + '/' + page;
	}

	const handleClickColapse = (itemList:string) =>
	{
		const pos = accordionItens.indexOf(itemList);

		if(pos == -1)
		{
			setAccordionItens(atual  => [...atual, itemList]);
		}
		else
		{
			accordionItens.splice(pos, 1);

			setAccordionItens(() => [...accordionItens]);
		}
	}

	const activeMenu = (ehBackground:boolean, itens:string[]) =>
	{
		const path:string = location.pathname.split('/')[1];

		if(itens.length > 0 && itens.includes(path))
		{
			return [(ehBackground ? theme.palette.info.main : theme.palette.primary.contrastText), theme.palette.primary.contrastText, theme.palette.info.main]
		}
		else
			return [(ehBackground ? 'none' : theme.palette.text.primary), theme.palette.text.primary, 'none']
	}

	const returnIcon = (ICONE:EICONS, active:string) =>
	{
		switch (ICONE)
		{
			case EICONS.HOME : return <InfoOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.PROGRAMAS : return <LocalMoviesOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.SERIES : return <GroupWorkOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.OPCOES : return <VideoSettingsIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.PRODUTORAS : return <CameraIndoorOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.CONFIGURACAOES : return <SettingsOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.GENERO : return <CategoryOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.IDIOMAS : return <LanguageIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.LIST : return <DriveFolderUploadOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
			case EICONS.USUARIOS : return <ManageAccountsOutlinedIcon fontSize="small" sx={{ color: active }} />; break;
		}
	}

	const handleLogout = async () =>
	{
		await appContext?.usuario.LogOut();
	}

	return <>
		{
			!ehCarregando &&
				<Box sx={{ display: 'flex' }}>
					<AppBar position="fixed" open={open} style={{ backgroundColor: theme.palette.secondary.main }} sx={{display:"flex", flexFlow: 'row nowrap', justifyContent: 'space-between', alignItems: 'center'}}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="open drawer"
								onClick={handleDrawerOpen}
								edge="start"
								sx={{
									marginRight: 5,
									...(open && { display: 'none' }),
								}}
							>
								<MenuIcon />
							</IconButton>
							<Typography variant="pm" noWrap component="div" display={'flex'} alignItems={'center'}>
								<LogoFrm size={30} /> <Box component={'span'} sx={{px: 1}}>Acervo Digital</Box>
							</Typography>
						</Toolbar>
						{
							(user && (user.displayName || user.email)) &&
							<Box alignItems={'center'} sx={{mr: 5, display: {xs: 'none', sm: 'flex'}}}>
								<AccountCircleIcon sx={{marginRight: '5px'}} />
								<Typography component={'span'} variant='pxs'>{user.displayName ? user.displayName : user.email}</Typography>
							</Box>
						}
					</AppBar>
					<Drawer variant="permanent" open={open}>
						<DrawerHeader>
							<ListItem disablePadding>
								<ListItemButton onClick={handleDrawerClose} sx={{ minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2 }}>
									<ListItemIcon sx={{ minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center', }}>
										{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
									</ListItemIcon>
									<ListItemText secondary={"Fechar"} />
								</ListItemButton>
							</ListItem>
						</DrawerHeader>
						<List sx={{ paddingTop:'0'}}>
							{
								AppConfig.NAVEGACAO.map((parent:IPropsNavigacao,keyParent) =>
									<React.Fragment key={keyParent}>
										{
											userRoleAdmin ?
												<>
													<Divider />
													<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, parent.activeMenu)[0]}}>
														<ListItemButton
															sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2}}
															title={parent.title}
															onClick={() => { parent.pathname ? handleGoTo(parent.pathname) : handleClickColapse('colapse_'+keyParent) }}
														>
															<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center',}}>
																{returnIcon(parent.icon, activeMenu(false, parent.activeMenu)[1])}
															</ListItemIcon>
															<ListItemText primary={parent.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, parent.activeMenu)[1], "& span": { fontSize:"0.9rem" } }} />
															{
																parent.submenu.length > 0 &&
																<>
																	{
																	accordionItens.indexOf('colapse_'+keyParent) >= 0 ?
																		<ExpandLess sx={{color:activeMenu(false, parent.activeMenu)[1]}} />
																	:
																		<ExpandMore sx={{color:activeMenu(false, parent.activeMenu)[1]}} />
																	}
																</>
															}
														</ListItemButton>
													</ListItem>
													{
														parent.submenu && parent.submenu.length > 0 && parent.submenu.map((child,keyChild) =>
															<Collapse in={accordionItens.indexOf('colapse_'+keyParent) >= 0 ? true : false} timeout="auto" unmountOnExit key={keyChild}>
																<List component="div" disablePadding>
																	<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, child.activeMenu)[2]}}>
																		<ListItemButton
																			sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', pl: 2}}
																			title={child.title}
																			onClick={() => {child.pathname ? handleGoTo(child.pathname) : handleClickColapse('colapseChild_'+keyChild)}}
																		>
																			<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center', marginLeft: open ? 2.5 : 0, }}>
																				{returnIcon(child.icon, activeMenu(false, child.activeMenu)[0])}
																			</ListItemIcon>
																			<ListItemText primary={child.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, child.activeMenu)[0], "& span": { fontSize:"0.85rem" } }} />
																			{
																				child.submenu.length > 0 &&
																				<>
																					{accordionItens.indexOf('colapseChild_'+keyChild) >= 0 ? <ExpandLess /> : <ExpandMore />}
																				</>
																			}
																		</ListItemButton>
																		{
																			child.submenu.map((granchild,keyGranChild) =>
																				<Collapse in={accordionItens.indexOf('colapseChild_'+keyChild) >= 0 ? true : false} timeout="auto" unmountOnExit key={keyGranChild}>
																					<List component="div" disablePadding>
																						<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, granchild.activeMenu)[2]}}>
																							<ListItemButton
																								sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', pl: 2}}
																								title={granchild.title}
																								onClick={() => { granchild.pathname ? handleGoTo(granchild.pathname) : () => {} }}
																							>
																								<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center',}}>
																									{returnIcon(granchild.icon, activeMenu(false, granchild.activeMenu)[0])}
																								</ListItemIcon>
																								<ListItemText className='' primary={granchild.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, granchild.activeMenu)[0], "& span": { fontSize:"0.85rem" } }} />
																							</ListItemButton>
																						</ListItem>
																					</List>
																				</Collapse>
																			)
																		}
																	</ListItem>
																</List>
															</Collapse>
														)
													}
												</>
												: parent.tipoPage === ETABLE.PROGRAMAS || parent.tipoPage === ETABLE.SERIES ? 
													<>
														<Divider />
														<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, parent.activeMenu)[0]}}>
															<ListItemButton
																sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2}}
																title={parent.title}
																onClick={() => { parent.pathname ? handleGoTo(parent.pathname) : handleClickColapse('colapse_'+keyParent) }}
															>
																<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center',}}>
																	{returnIcon(parent.icon, activeMenu(false, parent.activeMenu)[1])}
																</ListItemIcon>
																<ListItemText primary={parent.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, parent.activeMenu)[1], "& span": { fontSize:"0.9rem" } }} />
																{
																	parent.submenu.length > 0 &&
																	<>
																		{
																		accordionItens.indexOf('colapse_'+keyParent) >= 0 ?
																			<ExpandLess sx={{color:activeMenu(false, parent.activeMenu)[1]}} />
																		:
																			<ExpandMore sx={{color:activeMenu(false, parent.activeMenu)[1]}} />
																		}
																	</>
																}
															</ListItemButton>
														</ListItem>
														{
															parent.submenu && parent.submenu.length > 0 && parent.submenu.map((child,keyChild) =>
																<Collapse in={accordionItens.indexOf('colapse_'+keyParent) >= 0 ? true : false} timeout="auto" unmountOnExit key={keyChild}>
																	<List component="div" disablePadding>
																		<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, child.activeMenu)[2]}}>
																			<ListItemButton
																				sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', pl: 2}}
																				title={child.title}
																				onClick={() => {child.pathname ? handleGoTo(child.pathname) : handleClickColapse('colapseChild_'+keyChild)}}
																			>
																				<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center', marginLeft: open ? 2.5 : 0, }}>
																					{returnIcon(child.icon, activeMenu(false, child.activeMenu)[0])}
																				</ListItemIcon>
																				<ListItemText primary={child.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, child.activeMenu)[0], "& span": { fontSize:"0.85rem" } }} />
																				{
																					child.submenu.length > 0 &&
																					<>
																						{accordionItens.indexOf('colapseChild_'+keyChild) >= 0 ? <ExpandLess /> : <ExpandMore />}
																					</>
																				}
																			</ListItemButton>
																			{
																				child.submenu.map((granchild,keyGranChild) =>
																					<Collapse in={accordionItens.indexOf('colapseChild_'+keyChild) >= 0 ? true : false} timeout="auto" unmountOnExit key={keyGranChild}>
																						<List component="div" disablePadding>
																							<ListItem disablePadding sx={{ display: 'block', backgroundColor: activeMenu(true, granchild.activeMenu)[2]}}>
																								<ListItemButton
																									sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', pl: 2}}
																									title={granchild.title}
																									onClick={() => { granchild.pathname ? handleGoTo(granchild.pathname) : () => {} }}
																								>
																									<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center',}}>
																										{returnIcon(granchild.icon, activeMenu(false, granchild.activeMenu)[0])}
																									</ListItemIcon>
																									<ListItemText className='' primary={granchild.title} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, granchild.activeMenu)[0], "& span": { fontSize:"0.85rem" } }} />
																								</ListItemButton>
																							</ListItem>
																						</List>
																					</Collapse>
																				)
																			}
																		</ListItem>
																	</List>
																</Collapse>
															)
														}
													</> 
												: null
										}
									</React.Fragment>
								)
							}
							<Divider />
							<ListItem disablePadding sx={{ display: 'block'}}>
								<ListItemButton
									sx={{minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2,}}
									title={'Sair'}
									onClick={handleLogout}
								>
									<ListItemIcon sx={{minWidth: 0, mr: open ? 1 : 'auto', justifyContent: 'center',}}>
										<LogoutIcon fontSize="small" color="error"/>
									</ListItemIcon>
									<ListItemText primary={'Sair'} sx={{ opacity: open ? 1 : 0, color: activeMenu(false, [])[1], "& span": { fontSize:"0.9rem" } }} />
								</ListItemButton>
							</ListItem>
							<Divider />
						</List>
					</Drawer>
					<Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                        flexGrow: 1,
                        overflow: 'auto',
								marginTop: "1rem",
								marginBottom: "1rem",
                    }}
                    >
                        <DrawerHeader />
                        {props.children}
					</Box>
				</Box>
		}
	</>
}

export default DashboardLayout;

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0, 0),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
	open?: boolean;
}

const AppBar = styled(MuiAppBar, {shouldForwardProp: (prop) => prop !== 'open'})
	<AppBarProps>(({ theme, open }) => ({
			zIndex: theme.zIndex.drawer + 1,
			transition: theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			...(open && {
				marginLeft: drawerWidth,
				width: `calc(100% - ${drawerWidth}px)`,
				transition: theme.transitions.create(['width', 'margin'], {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.enteringScreen,
				}),
			}),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme, open }) => ({
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: 'nowrap',
		boxSizing: 'border-box',
		...(open && {
			...openedMixin(theme),
			'& .MuiDrawer-paper': openedMixin(theme),
		}),
		...(!open && {
			...closedMixin(theme),
			'& .MuiDrawer-paper': closedMixin(theme),
		}),
	}),
);